"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageGS = void 0;
const WrapperGS_1 = require("../core/WrapperGS");
const gs = require("..");
class ImageGS extends WrapperGS_1.WrapperGS {
    constructor(el) {
        super(el);
        this._onLoadedToken = new gs.EventGSToken(() => { this.el.addEventListener('load', () => this._onLoadedToken.invoke()); });
        this.onLoaded = new gs.EventGS(this._onLoadedToken);
    }
    static ForHTMLElement(el) { return el.nodeName.toLowerCase() === "img"; }
    get src() { return this.el.src; }
    set src(value) { this.el.src = value; }
}
exports.ImageGS = ImageGS;
gs.WrapperGS.ExtendComponentsByHTMLElement(ImageGS);
//# sourceMappingURL=ImageGS.js.map